import {
  Box,
  Flex,
  VStack,
  Text,
  Center,
  useDisclosure,
} from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import AuthenticatedHeader from "../AuthenticatedHeader/AuthenticatedHeader";
import { Sidebar, INav } from "../SideBar/SideBar";
import { UserService } from "../../services/UserService";
import { BiCategory } from "react-icons/bi";
import { FaObjectUngroup } from "react-icons/fa6";
import { SiAltiumdesigner } from "react-icons/si";
import { MdOutlineAdminPanelSettings, MdOutlineMonitor } from "react-icons/md";
import { TbUsers } from "react-icons/tb";
import { RiUserSettingsLine } from "react-icons/ri";
import { GrDeploy } from "react-icons/gr";

export const Main = () => {
  const { isOpen, onToggle } = useDisclosure();

  // ✅ Use getParsedToken to safely extract roles
  const token = UserService.getParsedToken();
  const roles: string[] =
    token?.resource_access?.["analytics-service"]?.roles ?? [];

  const userNavs: INav[] = [
    {
      icon: BiCategory,
      link: "/platform/design/applications",
      label: "Applications",
      active: true,
      width: 4,
      height: 4,
      enabled: true,
      subNavs: [],
    },
    {
      icon: FaObjectUngroup,
      link: "/platform/design/objects",
      label: "Objects",
      active: true,
      width: 4,
      height: 4,
      enabled: true,
      subNavs: [],
    },
    {
      icon: MdOutlineMonitor,
      link: "/platform/design/monitor",
      label: "Monitor",
      active: true,
      width: 4,
      height: 4,
      enabled: true,
      subNavs: [],
    },
    {
      icon: TbUsers,
      link: "/platform/design/users",
      label: "Users",
      active: true,
      width: 4,
      height: 4,
      enabled: false,
      subNavs: [],
    },
    {
      icon: GrDeploy,
      link: "/platform/design/devops",
      label: "DevOps",
      active: true,
      width: 4,
      height: 4,
      enabled: false,
      subNavs: [],
    },
    {
      icon: MdOutlineAdminPanelSettings,
      link: "/platform/admin/administration",
      label: "Administration",
      active: true,
      width: 4,
      height: 4,
      enabled: roles.includes("Eizen") || roles.includes("Administrator"),
      subNavs: [],
    },
  ];
  const location = useLocation();

  const handleOnHelp = () => {
    // TODO: Help Functionality
  };

  const getNavs = (pathname: string) => {
    return userNavs.map((nav) => ({
      ...nav,
      active: pathname.includes(nav.link),
      subNavs: nav.subNavs
        ? nav.subNavs.map((subNav) => ({
            ...subNav,
            active: pathname.includes(subNav.link),
          }))
        : [],
    }));
  };

  const handleOnLogout = () => {
    UserService.doLogout();
  };

  return (
    <Box className="Main" bg="transparent" minHeight="100vh">
      <VStack spacing={0}>
        <Box width="100%" height="5vh" zIndex={999}>
          <AuthenticatedHeader />
        </Box>
        <Flex width="100%" minHeight="95vh">
          {!location.pathname.includes("/process") && (
            <Box
              flex="1"
              display={{ base: isOpen ? "block" : "none", xl: "block" }}
              height="95vh"
              zIndex={998}
            >
              <Sidebar
                navs={getNavs(location.pathname)}
                isOpen={isOpen}
                onToggle={onToggle}
                onHelp={handleOnHelp}
                onLogout={handleOnLogout}
              />
            </Box>
          )}
          <Box flex="9" width="80%" m={{ base: 4, lg: 8 }} bg="transparent">
            <Outlet />
            {/* <Center m={3}>
              <Text
                position="absolute"
                bottom="0"
                fontSize="14px"
                textColor="gray.500"
                mb={3}
              >
                Copyright © 2024 eizen V2.0 - All Rights Reserved.
              </Text>
            </Center> */}
          </Box>
        </Flex>
      </VStack>
    </Box>
  );
};
